/**
 * StartNewTable.tsx
 * This component used to create table from a host
 */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectLocalPlayerEmail } from "../../../logic/localPlayer/slice";
import { getLocalPlayer } from "../../../logic/localPlayer/thunks";
import { selectTableCode } from "../../../logic/table/slice";
import { createTable } from "../../../logic/table/thunks";
import { SessionKeys, setSession } from "../../../utils/SessionSettings";
import Loading from "../../components/Loading";

export const StartNewTable = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { tableCode } = useSelector(selectTableCode);
  const { localPlayerEmail } = useSelector(selectLocalPlayerEmail);

  useEffect(() => {
    dispatch(getLocalPlayer());
  }, [dispatch]);

  // create table after received details of the local player
  useEffect(() => {
    if (localPlayerEmail) {
      setSession(SessionKeys.isBotTable, "false");
      setSession(SessionKeys.isLocalPlayerHost, "true");

      dispatch(createTable({ name: "Marketing Table" }));
    }
  }, [dispatch, localPlayerEmail]);

  // trigger detail when we have table code
  useEffect(() => {
    if (tableCode) {
      history.push(`table/${tableCode}`);
    }
  }, [history, tableCode]);

  return <Loading />;
};
